/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gf_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What radius should I use?`)
};

const es_gf_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué radio debo usar?`)
};

const de_gf_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welchen Radius sollte ich verwenden?`)
};

const nl_gf_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke straal moet ik gebruiken?`)
};

const fr_gf_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel rayon utiliser ?`)
};

const it_gf_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quale raggio devo usare?`)
};

const pt_br2_gf_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual raio devo usar?`)
};

const pt_gf_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que raio devo usar?`)
};

const ja_gf_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どの半径を使えばよいですか?`)
};

const zh_gf_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`应该使用哪个半径？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gf_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gf_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gf_faq_q3", locale)
	if (locale === "en") return en_gf_faq_q3(inputs)
	if (locale === "es") return es_gf_faq_q3(inputs)
	if (locale === "de") return de_gf_faq_q3(inputs)
	if (locale === "nl") return nl_gf_faq_q3(inputs)
	if (locale === "fr") return fr_gf_faq_q3(inputs)
	if (locale === "it") return it_gf_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_gf_faq_q3(inputs)
	if (locale === "pt") return pt_gf_faq_q3(inputs)
	if (locale === "ja") return ja_gf_faq_q3(inputs)
	return zh_gf_faq_q3(inputs)
};